/**
 * "Rebuild will bring back the choices you removed" (2026-10-28).
 *
 * The office can drop a choice (Clean & Flush, Rubber repair kit, …) from one
 * quote. Rebuild this quote and Refresh pricing re-draft the quote from
 * scratch, so every removed choice comes back. Keeping a removal through a
 * Rebuild is a later slice; until then the confirm says so plainly, naming
 * the choices. Renders nothing when nothing was removed.
 */
import { AlertTriangle } from "lucide-react";

export function RemovedChoicesWarning({ choices, action }: { choices: string[] | undefined; action: string }) {
    if (!choices || choices.length === 0) return null;
    return (
        <div
            data-testid="removed-choices-warning"
            className="flex gap-2 rounded-md border border-amber-300 bg-amber-50 p-2 text-[12.5px] text-amber-900 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100"
        >
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
            <span>
                <b>
                    {action} will bring back the choices you removed ({choices.join(", ")}).
                </b>{" "}
                Continue only if that&apos;s OK. You can remove them again after.
            </span>
        </div>
    );
}
